import { Schema } from "@effect/schema";
import { flow } from "effect";
import {
  camelToSnake,
  kebabToSnake,
  snakeToCamel,
  snakeToKebab,
} from "effect/String";

export const camelToKebab = flow(camelToSnake, snakeToKebab);
export const kebabToCamel = flow(kebabToSnake, snakeToCamel);

export const CamelFromKebab = Schema.transform(Schema.String, Schema.String, {
  decode: kebabToCamel,
  encode: camelToKebab,
});
